import { render, staticRenderFns } from "./CompanyDepartmentEdit.vue?vue&type=template&id=b01abde0"
import script from "./CompanyDepartmentEdit.vue?vue&type=script&lang=js"
export * from "./CompanyDepartmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports